import api from './request'

const findBindShopVoByShopId = (shopId, platform) => {
    return api.getPromise('platform/findBindShopVoByShopId', {shopId, platform})
}

export default {
    findBindShopVoByShopId,
}


// WEBPACK FOOTER //
// ./src/request/platformApi.js